import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { trigger, transition, style, animate } from '@angular/animations';
import { SDContactsToDisplay } from '@tecommon/structures/structures';


@Component({
    selector: 'sd-Contacts',
    templateUrl: './sdContacts.component.html',
    styles: [`
    td, th.mat-header-cell {
    text-align : center;
    }
    `],
    animations: [
        trigger('dropIn', [
            transition(':enter', [
                style({ transform: 'translateY(-40px)', opacity: 0 }),
                animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ transform: 'translateY(0)', opacity: 1 }),
                animate('500ms', style({ transform: 'translateY(-40px)', opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
/** SDContacts component*/
export class SDContactsComponent {

    public isLoading: boolean;
    public languageCode: string;
    dataSource: Array<SDContactsToDisplay>;

    public userId: string;
    public lastUpdatedDate: string;
    public lastUpdated: any;

    public loadingStatus: boolean;
    public successMessage: string;
    public errorMessage: string;

    displayedColumns: string[] = ['u_country', 'u_support_desk', 'u_phone_number'];
    
    constructor(private readonly http: HttpClient) {

        this.loadingStatus = true;
        this.http.get<SDContactsToDisplay[]>("/api/site/SDContacts").subscribe(result => {
            this.dataSource = result;
            this.lastUpdatedDate = this.getLastUpdatedDate(result);
            this.loadingStatus = false;
        },
        error => {
            console.log(error.error.message);
            this.loadingStatus = false;
        });
    }

    ngOnInit(): void {
        var darkMode = localStorage.getItem('myID.DarkMode');
        console.log(`Dark mode site setting is ${darkMode}`);
        const bodyElement = document.body;

        if (darkMode === "true") {
            bodyElement.classList.add('dark-theme');
            console.log('Dark theme added to body');
        } else {
            bodyElement.classList.remove('dark-theme');
            console.log('Dark theme removed from body');
        }
    }
    

    getLastUpdatedDate(result: any): string {
        result.sort((a, b) => 0 - (a.sys_updated_on > b.sys_updated_on ? 1 : -1));
        var lastUpdatedDate = result[0].sys_updated_on;
        result.sort((a, b) => 0 - (a.u_country > b.u_country ? -1 : 1));
        return lastUpdatedDate;
    }
       
}